import config from './config';
import { CreateUUID } from './utils/helper';
import SessionDB from './utils/sessionStorage';

const BASE_API = `${config.BASE_API}/api`;
const SSS_BASE_API = `${config.SSS_API_BASE_URL}/api`;

export const V1_API = `${BASE_API}/v1`;
export const CURRENT_API = V1_API;

export const API_ENDPOINTS = {
  auth: {
    DMEMBER_LOGIN: `${CURRENT_API}/login`,
    EXCHANGE_BRIDGE_TOKEN: (token: string) =>
      `${CURRENT_API}/auth/exchange-bridge-token?token=${encodeURIComponent(token)}`,
    GENERATE_BRIDGE_TOKEN: `${CURRENT_API}/auth/generate-bridge-token`,
    FORGOT_PASSWORD: `${CURRENT_API}/forgot-password`,
    OTP_REQUEST: (referralCode: string) =>
      `${CURRENT_API}/referral/${referralCode}`,
    REFRESH_TOKEN: `${CURRENT_API}/auth/refresh`,
    LOGOUT: `${CURRENT_API}/logout`,
    MEMBER_DETAILS: `${CURRENT_API}/member-details`,
    REGISTER_MEMBER: `${CURRENT_API}/register-member`,
    VALIDATE_LOGIN_ID: (loginId: string) => `${CURRENT_API}/validate-login-id/${loginId}`,
  },
  products: {
    GET_BY_CATEGORY: `${CURRENT_API}/products/category`,
    GET_CUSTOM: `${CURRENT_API}/products/custom`,
    FIRST_ORDER_PRODUCTS: `${CURRENT_API}/products/first-order`,
    MONTHLY_SHIPMENT_PRODUCTS: `${CURRENT_API}/products/category-103`,
    UPGRADE_CAMPAIGN_PRODUCTS: `${CURRENT_API}/products/by-category/106`,
    GET_BY_CATEGORIES: `${CURRENT_API}/products/categories`,
  },
  orders: {
    GET_HISTORY: `${CURRENT_API}/orders`,
    GET_DETAIL: `${CURRENT_API}/orders`,
    PURCHASE: `${CURRENT_API}/orders/purchase`,
    MEMBER_UPGRADE_PURCHASE: `${CURRENT_API}/special-registration-order/place`,
    GET_ORDER_AMOUNT: (orderId: string) => `${CURRENT_API}/orders/amount/${orderId}`,
  },

  invoices: {
    GET_INVOICE: (orderId: string) => `${CURRENT_API}/invoices/order/${orderId}`,
  },

  payment: {
    INITIALIZE: `${CURRENT_API}/payment/initialize`,
    FIRST_PAYMENT: `${CURRENT_API}/first-payment/initiate`,
    INITIALIZE_PIX: `${CURRENT_API}/payment/initialize-pix`,
    REGISTER_CARD: `${CURRENT_API}/payment/register-card`,
    GET_CREDIT_CARDS: `${CURRENT_API}/credit-cards`,
    EXISTING_CARD: `${CURRENT_API}/payment/existing-card`,
    UPDATE_CREDIT_CARD_MEMO: (cardId: string) => `${CURRENT_API}/credit-cards/${cardId}/memo`,
    DELETE_CREDIT_CARD: (cardId: string) => `${CURRENT_API}/credit-cards/${cardId}`,
  },

  userProfile: {
    GET_PROFILE: `${CURRENT_API}/dmember`,
    UPDATE_PROFILE: `${CURRENT_API}/dmember`,
    CHANGE_PASSWORD: `${CURRENT_API}/dmember/change-password`,
    GET_DASHBOARD: `${CURRENT_API}/dashboard`,

    UPDATE_LANGUAGE: `${CURRENT_API}/member/update-language`,

    GET_DASHBOARD_NOTICE: `${CURRENT_API}/dashboard/notice-alert`,
    GET_ALERTS: `${CURRENT_API}/alerts`,
  },

  blockchain: {
    GET_ADDRESSES: `${CURRENT_API}/blockchain`,
    ADD_ADDRESS: `${CURRENT_API}/blockchain`,
    UPDATE_ADDRESS: (no: number) => `${CURRENT_API}/blockchain/${no}`,
    DELETE_ADDRESS: (no: number) => `${CURRENT_API}/blockchain/${no}`,

  },

  subscriptions: {
    GET_SUBSCRIPTION_INFO: `${CURRENT_API}/orders/subscription/info`,
    SUBSCRIBE_MONTHLY: `${CURRENT_API}/orders/subscription`,
    UPDATE_QUANTITY: `${CURRENT_API}/orders/subscription/update`,
    CANCEL_AUTOSHIP: (orderId: string) =>
      `${CURRENT_API}/orders/cancel/autoship/${orderId}`,
    STOP_SUBSCRIPTION: `${CURRENT_API}/orders/cancel/autoship`,
    GET_SELECTED_CARD: `${CURRENT_API}/autoship/credit-card`,
    SET_SELECTED_CARD: `${CURRENT_API}/orders/subscription/update`,
  },
  billing: {
    GET_BILLING_HISTORY: `${CURRENT_API}/billing`,
  },

  commissions: {
    GET_COMMISSIONS: `${CURRENT_API}/dmember/commission`,
    GET_COMMISSIONS_MAIN: `${CURRENT_API}/commissions/allcommissions`,
  },

  referredMembers: {
    GET_RECRUITS: `${CURRENT_API}/member/recruits`,
  },

  placementMembers: {
    GET_LIST: `${CURRENT_API}/placement-members`,
    PLACE: `${CURRENT_API}/placement/member`,
    FREE_POSITION_ADD: `${CURRENT_API}/member/free-position`,
  },

  documents: {
    LIST: `${CURRENT_API}/documents`,
  },

  savingWallet: {
    GET_SUMMARY: `${CURRENT_API}/wallet/summary`,
    GET_TRANSACTIONS: `${CURRENT_API}/wallet/summary`,
  },

  sss: {
    GET_TREE_TOKEN: `${CURRENT_API}/sss/token`,
  },


  test: {
    DUMMY_API: `/test`,
    PUBLIC_TEST_API: 'https://jsonplaceholder.typicode.com/todos/8',
  },
} as const;

export const DEFAULT_AVATAR = 'https://randomuser.me/api/portraits/men/32.jpg';

type Token = string | null;

export const APIHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Debug-Id': CreateUUID().replace(/-/g, ''),
};

export const APIHeadersForMultipartFormData = {
  Accept: 'application/json',
  'Debug-Id': CreateUUID().replace(/-/g, ''),
};
export const APIHeadersTypeJSON = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Debug-Id': CreateUUID().replace(/-/g, ''),
};
export const APIHeadersWithAuth = (token?: Token) => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Debug-Id': CreateUUID().replace(/-/g, ''),
  Authorization: `Bearer ${token || SessionDB.getAccessToken()}`,
});

export const APIHeadersWithAuthProto = (token?: Token) => ({
  Accept: 'application/x-protobuf',
  'Content-Type': 'application/json',
  'Debug-Id': CreateUUID().replace(/-/g, ''),
  Authorization: `Bearer ${token || SessionDB.getAccessToken()}`,
});

export const LOCAL_STORAGE_KEYS = {
  persistStartSubscription: {
    SELECTED_PRODUCTS: 'persist-start-subscription-selected-products',
    IS_PAYMENT_MODAL_OPEN: 'persist-start-subscription-is-payment-modal-open',
    PREVIOUS_PAYMENT_METHODS: 'persist-start-subscription-previous-payment-methods',
  }
} as const;

// ============================================
// COUNTRY-SPECIFIC API ENDPOINTS (RegisterFlow only)
// ============================================
// Separate configurations for Brazil and Cambodia
// For now they use the same URL, but structured separately
// To change URLs later, just update the apiBase in each config
// ============================================

/**
 * Brazil (BR) - Registration Flow API Endpoints
 * Change V1_API to a different URL when Brazil needs separate API
 */
const BR_REGISTER_ENDPOINTS = (() => {
  const apiBase = V1_API; // Change this to Brazil-specific URL later
  return {
    auth: {
      OTP_REQUEST: (referralCode: string) => `${apiBase}/referral/${referralCode}`,
      VALIDATE_LOGIN_ID: (loginId: string) => `${apiBase}/validate-login-id/${loginId}`,
      REGISTER_MEMBER: `${apiBase}/register-member`,
    },
    products: {
      FIRST_ORDER_PRODUCTS: `${apiBase}/products/first-order`,
      GET_CUSTOM: `${apiBase}/products/custom`,
      MONTHLY_SHIPMENT_PRODUCTS: `${apiBase}/products/category-103`,
      GET_BY_CATEGORIES: `${apiBase}/products/categories`,
    },
    payment: {
      FIRST_PAYMENT: `${apiBase}/first-payment/initiate`,
      INITIALIZE_PIX: `${apiBase}/payment/initialize-pix`,
    },
  };
})();

/**
 * Cambodia (KH) - Registration Flow API Endpoints
 * Change V1_API to a different URL when Cambodia needs separate API
 */
const KH_REGISTER_ENDPOINTS = (() => {
  const apiBase = V1_API; // Change this to Cambodia-specific URL later
  return {
    auth: {
      OTP_REQUEST: (referralCode: string) => `${apiBase}/referral/${referralCode}`,
      VALIDATE_LOGIN_ID: (loginId: string) => `${apiBase}/validate-login-id/${loginId}`,
      REGISTER_MEMBER: `${apiBase}/register-member`,
    },
    products: {
      FIRST_ORDER_PRODUCTS: `${apiBase}/products/custom-by-category?baseCategoryId=201&subscriptionCategoryId=202`,
      GET_CUSTOM: `${apiBase}/products/custom`,
      MONTHLY_SHIPMENT_PRODUCTS: `${apiBase}/products/category?categoryId=204`,
      GET_BY_CATEGORIES: `${apiBase}/products/categories`,
    },
    payment: {
      FIRST_PAYMENT: `${apiBase}/first-payment/initiate`,
      INITIALIZE_PIX: `${apiBase}/payment/initialize-pix`,
    },
  };
})();

const REGISTER_ENDPOINTS_MAP = {
  BR: BR_REGISTER_ENDPOINTS,
  KH: KH_REGISTER_ENDPOINTS,
  DEFAULT: BR_REGISTER_ENDPOINTS,
} as const;

/**
 * Get country-specific API endpoints for RegisterFlow
 * @param countryCode - ISO country code (BR, KH)
 * @returns API endpoints for that country's registration flow
 * 
 * @example
 * // In RegisterFlow saga:
 * const endpoints = getRegisterFlowEndpoints('BR');
 * const otpUrl = endpoints.auth.OTP_REQUEST(referralCode);
 */
export const getRegisterFlowEndpoints = (countryCode?: string) => {
  const code = (countryCode?.toUpperCase() || 'DEFAULT') as keyof typeof REGISTER_ENDPOINTS_MAP;
  return REGISTER_ENDPOINTS_MAP[code] || REGISTER_ENDPOINTS_MAP.DEFAULT;
};

// ============================================
// DASHBOARD CONTAINER ENDPOINTS
// ============================================

// ============================================
// COUNTRY API CONFIGURATION (Global -> Country -> Page)
// ============================================

// ============================================
// COUNTRY API CONFIGURATION (Global -> Country -> Page)
// ============================================

// ============================================
// COUNTRY API CONFIGURATION (Global -> Country -> Page)
// No defaults. Every country must explicitly define endpoints.
// ============================================

export const COUNTRY_API_CONFIG = {
  BR: {
    dashboardPage: {
      information: {
        GET_ENABLED: (page: number, pageSize: number) =>
          `${V1_API}/information/enabled?page=${page}&pageSize=${pageSize}`,
      },
      sss: {
        GET_TREE_TOKEN: API_ENDPOINTS.sss.GET_TREE_TOKEN,
      },
      savingWallet: {
        GET_SUMMARY: API_ENDPOINTS.savingWallet.GET_SUMMARY,
      },
      userProfile: {
        GET_DASHBOARD: API_ENDPOINTS.userProfile.GET_DASHBOARD,
      },
      products: {
        UPGRADE_CAMPAIGN_PRODUCTS: API_ENDPOINTS.products.UPGRADE_CAMPAIGN_PRODUCTS,
      },
    },

    makeOrderPage: {
      products: {
        GET_CUSTOM: (page: number, size: number, sortOrder: string) =>
          `${API_ENDPOINTS.products.GET_CUSTOM}?page=${page}&size=${size}&sortOrder=${sortOrder}`,
      },
      orders: {
        PURCHASE: API_ENDPOINTS.orders.PURCHASE,
      },
      payment: {
        INITIALIZE: API_ENDPOINTS.payment.INITIALIZE,
        EXISTING_CARD: API_ENDPOINTS.payment.EXISTING_CARD,
        GET_CREDIT_CARDS: API_ENDPOINTS.payment.GET_CREDIT_CARDS,
      },
      userProfile: {
        GET_DASHBOARD: API_ENDPOINTS.userProfile.GET_DASHBOARD,
      },
    },

    orderHistoryPage: {
      orders: {
        GET_HISTORY: API_ENDPOINTS.orders.GET_HISTORY,
      },
      invoices: {
        GET_INVOICE: (orderId: string) => API_ENDPOINTS.invoices.GET_INVOICE(orderId),
      },
    },

    userProfilePage: {
      userProfile: {
        GET_PROFILE: API_ENDPOINTS.userProfile.GET_PROFILE,
        UPDATE_PROFILE: API_ENDPOINTS.userProfile.UPDATE_PROFILE,
        CHANGE_PASSWORD: API_ENDPOINTS.userProfile.CHANGE_PASSWORD,
      },
      payment: {
        REGISTER_CARD: API_ENDPOINTS.payment.REGISTER_CARD,
        GET_CREDIT_CARDS: API_ENDPOINTS.payment.GET_CREDIT_CARDS,
        UPDATE_CREDIT_CARD_MEMO: (cardId: string) => API_ENDPOINTS.payment.UPDATE_CREDIT_CARD_MEMO(cardId),
        DELETE_CREDIT_CARD: (cardId: string) => API_ENDPOINTS.payment.DELETE_CREDIT_CARD(cardId),
      },
      blockchain: {
        GET_ADDRESSES: API_ENDPOINTS.blockchain.GET_ADDRESSES,
        ADD_ADDRESS: API_ENDPOINTS.blockchain.ADD_ADDRESS,
        UPDATE_ADDRESS: (no: number) => API_ENDPOINTS.blockchain.UPDATE_ADDRESS(no),
        DELETE_ADDRESS: (no: number) => API_ENDPOINTS.blockchain.DELETE_ADDRESS(no),
      },
    },

    subscriptionsPage: {
      subscriptions: {
        GET_SUBSCRIPTION_INFO: API_ENDPOINTS.subscriptions.GET_SUBSCRIPTION_INFO,
        SUBSCRIBE_MONTHLY: API_ENDPOINTS.subscriptions.SUBSCRIBE_MONTHLY,
        UPDATE_QUANTITY: API_ENDPOINTS.subscriptions.UPDATE_QUANTITY,
        CANCEL_AUTOSHIP: (orderId: string) => API_ENDPOINTS.subscriptions.CANCEL_AUTOSHIP(orderId),
        STOP_SUBSCRIPTION: API_ENDPOINTS.subscriptions.STOP_SUBSCRIPTION,
      },
      billing: {
        GET_BILLING_HISTORY: API_ENDPOINTS.billing.GET_BILLING_HISTORY,
      },
      payment: {
        REGISTER_CARD: API_ENDPOINTS.payment.REGISTER_CARD,
        GET_CREDIT_CARDS: API_ENDPOINTS.payment.GET_CREDIT_CARDS,
        UPDATE_CREDIT_CARD_MEMO: (cardId: string) => API_ENDPOINTS.payment.UPDATE_CREDIT_CARD_MEMO(cardId),
        DELETE_CREDIT_CARD: (cardId: string) => API_ENDPOINTS.payment.DELETE_CREDIT_CARD(cardId),
      },
      products: {
        GET_BY_CATEGORY: (categoryId: number, page: number, size: number, sortOrder: string) =>
          `${API_ENDPOINTS.products.GET_BY_CATEGORY}?categoryId=${categoryId}&page=${page}&size=${size}&sortOrder=${sortOrder}`,
      },
    },

    referredMembersPage: {
      referredMembers: {
        GET_RECRUITS: (memberCode: string, bc: string) => `${API_ENDPOINTS.referredMembers.GET_RECRUITS}?memberCode=${memberCode}&bc=${bc}`,
      },
    },

    savingWalletPage: {
      savingWallet: {
        GET_SUMMARY: API_ENDPOINTS.savingWallet.GET_SUMMARY,
        GET_TRANSACTIONS: API_ENDPOINTS.savingWallet.GET_TRANSACTIONS,
      },
    },

    unplacedMembersPage: {
      placementMembers: {
        GET_LIST: (page: number, pageSize: number, searchKeyword?: string) => {
          let url = `${API_ENDPOINTS.placementMembers.GET_LIST}?page=${page}&pageSize=${pageSize}`;
          if (searchKeyword && searchKeyword.trim()) {
            url += `&searchKeyword=${encodeURIComponent(searchKeyword.trim())}`;
          }
          return url;
        },
        PLACE: API_ENDPOINTS.placementMembers.PLACE,
      },
      sss: {
        GET_TREE_TOKEN: API_ENDPOINTS.sss.GET_TREE_TOKEN,
      },
    },

    orderDetailPage: {
      orders: {
        GET_DETAIL: (orderId: string) => `${API_ENDPOINTS.orders.GET_DETAIL}/${orderId}`,
      },
      invoices: {
        GET_INVOICE: (orderId: string) => API_ENDPOINTS.invoices.GET_INVOICE(orderId),
      },
    },
  },

  KH: {
    dashboardPage: {
      information: {
        GET_ENABLED: (page: number, pageSize: number) =>
          `${V1_API}/information/enabled?page=${page}&pageSize=${pageSize}`,
      },
      sss: {
        GET_TREE_TOKEN: API_ENDPOINTS.sss.GET_TREE_TOKEN,
      },
      savingWallet: {
        GET_SUMMARY: API_ENDPOINTS.savingWallet.GET_SUMMARY,
      },
      userProfile: {
        GET_DASHBOARD: API_ENDPOINTS.userProfile.GET_DASHBOARD,
      },
      products: {
        UPGRADE_CAMPAIGN_PRODUCTS: `${V1_API}/products/by-category/206`,
      },
    },

    makeOrderPage: {
      products: {
        GET_CUSTOM: (page: number, size: number, sortOrder: string) =>
          `${V1_API}/products/custom-by-category?baseCategoryId=203&subscriptionCategoryId=204&page=${page}&size=${size}&sortOrder=${sortOrder}`,
      },
      orders: {
        PURCHASE: API_ENDPOINTS.orders.PURCHASE,
      },
      payment: {
        INITIALIZE: API_ENDPOINTS.payment.INITIALIZE,
        EXISTING_CARD: API_ENDPOINTS.payment.EXISTING_CARD,
        GET_CREDIT_CARDS: API_ENDPOINTS.payment.GET_CREDIT_CARDS,
      },
      userProfile: {
        GET_DASHBOARD: API_ENDPOINTS.userProfile.GET_DASHBOARD,
      },
    },

    orderHistoryPage: {
      orders: {
        GET_HISTORY: API_ENDPOINTS.orders.GET_HISTORY,
      },
      invoices: {
        GET_INVOICE: (orderId: string) => API_ENDPOINTS.invoices.GET_INVOICE(orderId),
      },
    },

    userProfilePage: {
      userProfile: {
        GET_PROFILE: API_ENDPOINTS.userProfile.GET_PROFILE,
        UPDATE_PROFILE: API_ENDPOINTS.userProfile.UPDATE_PROFILE,
        CHANGE_PASSWORD: API_ENDPOINTS.userProfile.CHANGE_PASSWORD,
      },
      payment: {
        REGISTER_CARD: API_ENDPOINTS.payment.REGISTER_CARD,
        GET_CREDIT_CARDS: API_ENDPOINTS.payment.GET_CREDIT_CARDS,
        UPDATE_CREDIT_CARD_MEMO: (cardId: string) => API_ENDPOINTS.payment.UPDATE_CREDIT_CARD_MEMO(cardId),
        DELETE_CREDIT_CARD: (cardId: string) => API_ENDPOINTS.payment.DELETE_CREDIT_CARD(cardId),
      },
      blockchain: {
        GET_ADDRESSES: API_ENDPOINTS.blockchain.GET_ADDRESSES,
        ADD_ADDRESS: API_ENDPOINTS.blockchain.ADD_ADDRESS,
        UPDATE_ADDRESS: (no: number) => API_ENDPOINTS.blockchain.UPDATE_ADDRESS(no),
        DELETE_ADDRESS: (no: number) => API_ENDPOINTS.blockchain.DELETE_ADDRESS(no),
      },
    },

    subscriptionsPage: {
      subscriptions: {
        GET_SUBSCRIPTION_INFO: API_ENDPOINTS.subscriptions.GET_SUBSCRIPTION_INFO,
        SUBSCRIBE_MONTHLY: API_ENDPOINTS.subscriptions.SUBSCRIBE_MONTHLY,
        UPDATE_QUANTITY: API_ENDPOINTS.subscriptions.UPDATE_QUANTITY,
        CANCEL_AUTOSHIP: (orderId: string) => API_ENDPOINTS.subscriptions.CANCEL_AUTOSHIP(orderId),
        STOP_SUBSCRIPTION: API_ENDPOINTS.subscriptions.STOP_SUBSCRIPTION,
      },
      billing: {
        GET_BILLING_HISTORY: API_ENDPOINTS.billing.GET_BILLING_HISTORY,
      },
      payment: {
        REGISTER_CARD: API_ENDPOINTS.payment.REGISTER_CARD,
        GET_CREDIT_CARDS: API_ENDPOINTS.payment.GET_CREDIT_CARDS,
        UPDATE_CREDIT_CARD_MEMO: (cardId: string) => API_ENDPOINTS.payment.UPDATE_CREDIT_CARD_MEMO(cardId),
        DELETE_CREDIT_CARD: (cardId: string) => API_ENDPOINTS.payment.DELETE_CREDIT_CARD(cardId),
      },
      products: {
        GET_BY_CATEGORY: (categoryId: number, page: number, size: number, sortOrder: string) =>
          `${V1_API}/products/category?categoryId=${categoryId}&page=${page}&size=${size}&sortOrder=${sortOrder}`,
      },
    },

    referredMembersPage: {
      referredMembers: {
        GET_RECRUITS: (memberCode: string, bc: string) => `${API_ENDPOINTS.referredMembers.GET_RECRUITS}?memberCode=${memberCode}&bc=${bc}`,
      },
    },

    savingWalletPage: {
      savingWallet: {
        GET_SUMMARY: API_ENDPOINTS.savingWallet.GET_SUMMARY,
        GET_TRANSACTIONS: API_ENDPOINTS.savingWallet.GET_TRANSACTIONS,
      },
    },

    unplacedMembersPage: {
      placementMembers: {
        GET_LIST: (page: number, pageSize: number, searchKeyword?: string) => {
          let url = `${API_ENDPOINTS.placementMembers.GET_LIST}?page=${page}&pageSize=${pageSize}`;
          if (searchKeyword && searchKeyword.trim()) {
            url += `&searchKeyword=${encodeURIComponent(searchKeyword.trim())}`;
          }
          return url;
        },
        PLACE: API_ENDPOINTS.placementMembers.PLACE,
      },
      sss: {
        GET_TREE_TOKEN: API_ENDPOINTS.sss.GET_TREE_TOKEN,
      },
    },

    orderDetailPage: {
      orders: {
        GET_DETAIL: (orderId: string) => `${API_ENDPOINTS.orders.GET_DETAIL}/${orderId}`,
      },
      invoices: {
        GET_INVOICE: (orderId: string) => API_ENDPOINTS.invoices.GET_INVOICE(orderId),
      },
    },

    groupPointDetailsPage: {
      groupPoints: {
        GET_LIST: (baseUrl: string) => `${baseUrl}/api/v1/group-points`,
      },
    },

    commissionsPage: {
      commissions: {
        GET_COMMISSIONS_MAIN: (offset: number, limit: number) =>
          `${API_ENDPOINTS.commissions.GET_COMMISSIONS_MAIN}?offset=${offset}&limit=${limit}`,
      },
      userProfile: {
        GET_PROFILE: API_ENDPOINTS.userProfile.GET_PROFILE,
      },
    },

    documentsPage: {
      documents: {
        LIST: API_ENDPOINTS.documents.LIST,
      },
    },
  },


} as const;

// Type inference for the config
export type CountryApiConfigType = typeof COUNTRY_API_CONFIG.KH; // Use KH as the shape definition (most complete)

/**
 * Get API endpoints for a specific country and page.
 */
export const getCountryApiEndpoints = <T extends keyof CountryApiConfigType>(
  countryCode: string | undefined,
  page: T
): CountryApiConfigType[T] => {
  // strict check to ensure we only access defined keys
  const code = (countryCode?.toUpperCase()) as keyof typeof COUNTRY_API_CONFIG;
  const config = COUNTRY_API_CONFIG[code] || COUNTRY_API_CONFIG.BR; // Fallback to BR
  return (config as CountryApiConfigType)[page];
};
